// filename: src/impl/onyx.ts
import * as chain from '../config/chain';
import { createOnyxFacade } from './onyx-core';

export const onyx = createOnyxFacade((config) => chain.resolveConfig(config));
